import { useState } from "react";

const defaultSort = {
  sortText: "Position",
  sortId: "sortItem.position",
  sortAttribute: "position",
  sortDirection: "ASC",
};

export const useSort = (props = {}) =>
  useState(() => Object.assign({}, defaultSort, props));
